import { makeStyles } from '@material-ui/core/styles'
import { clearAfter } from 'swisscard/components/common/mixins'
import { computeDefaultLinkStyles } from 'swisscard/components/typography/link_styles'

import type { Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => {
  const {
    '&:hover': hoverLinkStyles,
    '&:active': activeLinkStyles,
    ...defaultLinkStyles
  } = computeDefaultLinkStyles(theme)

  return {
    application: {
      backgroundColor: theme.palette.common.white,
      padding: '0 0 40px',
      fontFamily: theme.customFonts.main.fontFamily,
      minWidth: 300,
      boxSizing: 'border-box',
      color: theme.customColors.text.main,
      fontSize: 18,
      lineHeight: '24px',
      fontWeight: 400,

      '& *': {
        boxSizing: 'border-box',
        outline: 'none',
        fontVariantLigatures: 'none',
      },

      '& *::before': {
        boxSizing: 'border-box',
      },

      '& *::after': {
        boxSizing: 'border-box',
      },

      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
    },
    applicationInner: {
      margin: '0 auto',
      padding: '55px 15px 0',

      '& a': {
        ...defaultLinkStyles,
      },
      '& a:hover': {
        ...hoverLinkStyles,
      },
      '&:active': {
        ...activeLinkStyles,
      },
      '& label a': {
        color: 'inherit',
      },

      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    logoWrapper: {
      ...clearAfter,
    },
    logo: {
      backgroundImage: `url(${theme.customImages?.logo})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      height: '54px',

      [theme.breakpoints.up('lg')]: {
        float: 'right',
        width: '54px',
        margin: '13px 20px 0 0',
      },
    },
    tagline: {
      backgroundImage: `url(${theme.customImages?.tagline})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      height: '30px',
      marginBottom: '10px',
    },
  }
})

export default useStyles
